var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20711 10.5C7.76165 10.5 7.53857 11.0386 7.85355 11.3536L11.6464 15.1464C11.8417 15.3417 12.1583 15.3417 12.3536 15.1464L16.1464 11.3536C16.4614 11.0386 16.2383 10.5 15.7929 10.5H8.20711Z",
    fill: "#475569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownDownIcon);
export default __webpack_public_path__ + "static/media/DropdownDownIcon.c542bfad24539e4ec61371a19667b124.svg";
export { ForwardRef as ReactComponent };